import { render } from 'react-dom'
import Achievements from '../../AboutUs/Achievements'

document.addEventListener('DOMContentLoaded', () => {
  render(<Achievements />, document.getElementById('about-us-achievements'))
})
